import {
    ContractorPaymentTotals,
    Payroll,
    PayrollTotals,
} from "../../types/payroll";
import { PayrollSchema } from "../../schemas/payroll.schema";
import { isoStringOrNull, unpackDateOrNull } from "../dto-helpers";

export class PayrollDto {
    static deserialize(dto: PayrollSchema): Payroll {
        return {
            ...dto,
            processedDate: unpackDateOrNull(dto.processedDate),
            calculatedAt: unpackDateOrNull(dto.calculatedAt),
            payPeriodStartDate: unpackDateOrNull(dto.payPeriodStartDate),
            payPeriodEndDate: unpackDateOrNull(dto.payPeriodEndDate),
            checkDate: unpackDateOrNull(dto.checkDate),
            createdAt: unpackDateOrNull(dto.createdAt),
            totals: structuredClone(dto.totals),
            contractorPaymentTotals: structuredClone(
                dto.contractorPaymentTotals,
            ),
        };
    }

    id: number;
    payrollUuid: string;
    companyUuid: string;
    entityId: number;
    offCycle: boolean;
    processed: boolean;
    processedDate: string | null;
    calculatedAt: string | null;
    payPeriodStartDate: string | null;
    payPeriodEndDate: string | null;
    payScheduleUuid?: string | null;
    checkDate: string | null;
    external: boolean;
    totals?: PayrollTotals | null;
    contractorPaymentTotals?: ContractorPaymentTotals | null;
    createdAt: string | null;

    constructor(payroll: Payroll) {
        this.id = payroll.id;
        this.payrollUuid = payroll.payrollUuid;
        this.companyUuid = payroll.companyUuid;
        this.entityId = payroll.entityId;
        this.offCycle = payroll.offCycle;
        this.processed = payroll.processed;
        this.processedDate = isoStringOrNull(payroll.processedDate);
        this.calculatedAt = isoStringOrNull(payroll.calculatedAt);
        this.payPeriodStartDate = isoStringOrNull(payroll.payPeriodStartDate);
        this.payPeriodEndDate = isoStringOrNull(payroll.payPeriodEndDate);
        this.payScheduleUuid = payroll.payScheduleUuid;
        this.checkDate = isoStringOrNull(payroll.checkDate);
        this.external = payroll.external;
        this.totals = structuredClone(payroll.totals);
        this.contractorPaymentTotals = structuredClone(
            payroll.contractorPaymentTotals,
        );
        this.createdAt = isoStringOrNull(payroll.createdAt);
    }
}
